import * as $ from 'jquery';
import Debouncer from '../lib/Debouncer';

export default function initAddClass() {
	const body = $(document.body);
	const win = $(window);
	const distance: number = 40;

	function init() {

		const css = 'scrolled';
		const eventHandler = function () {
			if ( win.scrollTop() < distance ) {
				body.removeClass( css );
			} else {
				body.addClass( css );
			}
		}
		eventHandler();
		win.on('scroll.addClass', (new Debouncer(eventHandler)).run);
	}

	init();
}